import React, {useContext, useEffect, useState} from 'react'
import useVideoConfigS3 from '../HelperComponent/useVideoConfigS3';
import axios from "axios";
import swal from "sweetalert";
import {serverInfo} from "../App";

const useVideoHandleWithCompress = (video=null,upKey=null,delKey=null) => {


    const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
    const [videoProgress, setProgress] = useState(0);
    const [videoUrl, setFileUrl] = useState('');
    const [videoKey, setFileKey] = useState('');
    const [videoWidth, setVideoWidth] = useState('');
    const [videoHeight, setVideoHeight] = useState('');

    const [uploadFile, setFile] = useState(null);

    useEffect(() => {
      setFile(video);
      setProgress(0);
      setFileUrl('')
    }, [video,delKey]);


    const handleUpload = async (video) => {
        const fData = new FormData();
        fData.append("video", video);
        fData.append("filePath", upKey+'/');

        console.log(upKey+video.name);
        let videoName = video.name.replace(/ /g, '_');
        const lastDotIndex = videoName.lastIndexOf(".");
        videoName =  videoName.substring(0, lastDotIndex)+'.mp4';

        setFileKey(upKey+'/'+videoName)
        // setFileUrl(videoCdnUrl+upKey+'/'+videoName)


        const response = await axios.post('/api/compress-video', fData, {
            // Optional: You can pass any additional headers here
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            // Optional: You can track the progress with the onUploadProgress callback
            onUploadProgress: (evt) => {
                const progressPercentage = parseInt(
                    // (evt.loaded * 100) / evt.total
                    (evt.loaded * 50) / evt.total
                );
                setProgress(progressPercentage);
                console.log(`Upload Progress: ${progressPercentage}%`);

            },
        });
        if(response){
            setFileKey(upKey+'/'+response.data.fileName)
            setVideoWidth(response.data.width)
            setVideoHeight(response.data.height)
            setFileUrl(videoCdnUrl+upKey+'/'+response.data.fileName)
            setProgress(100);
        }
        console.log('Upload Successful:', response.data);

    };

    if(uploadFile){
        handleUpload(uploadFile);
        setFile(null);
    }

    return [videoUrl,videoKey,videoProgress,videoHeight,videoWidth];
}

export default useVideoHandleWithCompress
